import { render, staticRenderFns } from "./IndemnitiesAndTerms.vue?vue&type=template&id=3a060da1&"
import script from "./IndemnitiesAndTerms.vue?vue&type=script&lang=ts&"
export * from "./IndemnitiesAndTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports